import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import axios from 'axios';
import { CurrencyEnum } from '@spectrocoin/sc-currencies';
import { getCurrencyNetworkURL } from '../endpoints';
import Network from '../interfaces/Network';
import { throwLoaderError } from '../helpers/loaderUtils';
import { RemoteError } from '../redux/SharedTypes';

export type NetworkInfo = {
	currencyCode: CurrencyEnum;
	networkName?: string;
};

export const networksQuery = (networkInfo?: NetworkInfo) =>
	queryOptions<Network[], RemoteError>({
		queryKey: ['currency-network', networkInfo?.currencyCode, networkInfo?.networkName],
		queryFn: () =>
			axios
				.get<Network[]>(
					getCurrencyNetworkURL(networkInfo!.currencyCode, networkInfo!.networkName)
				)
				.then(({ data }) => data)
				.catch(throwLoaderError),
		enabled: !!networkInfo,
	});

export const useNetworksQuery = (networkInfo?: NetworkInfo) => useQuery(networksQuery(networkInfo));
export const useNetworksSuspenseQuery = (networkInfo?: NetworkInfo) =>
	useSuspenseQuery(networksQuery(networkInfo));
